export default "__VITE_ASSET__BTL1_Ll9__"